import { useModal } from 'modals';

import GoButton from '@cartwhl/ui/input/GoButton';

export default function ContactButton({ label }: { label?: string }) {
  const { open } = useModal();

  const handleClick = () =>
    open('ENTERPRISE_CONTACT', { reason: 'pricing_plans' });

  return (
    <GoButton variant="animate" onClick={handleClick} type="button">
      {label ?? 'Contact us'}
    </GoButton>
  );
}
